import { useEffect } from "react";
import { measureTextZoom } from "./compact-mode.ts";

/**
 * Measure the rendered text scale once after the first paint and feed it to
 * compact mode. One frame later, so a style sheet the host injects has
 * applied.
 */
export function useTextZoom() {
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      measureTextZoom(document);
    });

    return () => window.cancelAnimationFrame(frame);
  }, []);
}
